// extracted by mini-css-extract-plugin
export default {"tournamentArea":"Area_tournamentArea__LPctV","counter":"Area_counter__UKETy","footer":"Area_footer__LX3Wm"};